import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IMondialRelayCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class MondialRelayCredentialsStore implements ICredentialsStore {
    private _changes: IMondialRelayCredentialsModel = {} as IMondialRelayCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get username() { return this._changes.username; };
    public get orderChannelId() { return this._changes.order_channel_id; };
    public get internalName() { return this._changes.internal_name; };
    public get apiKey() { return this._changes.api_key; };
    public get customerNumber() { return this._changes.customer_number; };
    public get apiSecret() { return this._changes.api_secret; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };
    
    setApiKey(value: string) {
        this._changes.api_key = value;
    };
    
    setApiSecret(value: string) {
        this._changes.api_secret = value;
    };

    setCustomerNumber(value: string) {
        this._changes.customer_number = value;
    };

    setOrderChannelId(value: string) {
        this._changes.order_channel_id = value;
    };

    setUsername(value: string) {
        this._changes.username = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default MondialRelayCredentialsStore;
